module.exports = __webpack_public_path__ + "static/media/no_img_player_detail_m.70e2df33.png";